import { sendGtmEvent } from "~/lib/gtm/gE";
import { sendWebEvent } from "~/lib/webevents/WebEventsClient";
import type { useUnauthorizedEventService } from "~/services/api/services/event";

export function sendAbTestEvent(
    sendBigQueryEvent: ReturnType<typeof useUnauthorizedEventService>,
    experimentId: string,
    variationId: string
): void {
    sendGtmEvent({
        event: "user_non_interaction",
        value: {
            event_name: "ab_test",
            widget: experimentId,
            meta_data: {
                test_name: experimentId,
                variant_name: variationId,
            },
        },
    });

    void sendWebEvent(sendBigQueryEvent, {
        event_name: "ab_test",
        event_type: "user_non_interaction",
        widget: experimentId,
        meta_data: {
            test_name: experimentId,
            variant_name: variationId,
        },
    });
}
